// Fields that can be used in both requirements and conditions
export const RFQ_FIELD_OPTIONS = [
  { value: 'customer', label: 'Customer', category: 'rfq' },
  { value: 'consignee', label: 'Consignee', category: 'rfq' },
  { value: 'consignor', label: 'Consignor', category: 'rfq' },
]

export const SHIPMENT_FIELD_OPTIONS = [
  { value: 'shipmentType', label: 'Shipment Type', category: 'shipment' },
  { value: 'origin', label: 'Origin', category: 'shipment' },
  { value: 'originType', label: 'Origin Type', category: 'shipment' },
  { value: 'destination', label: 'Destination', category: 'shipment' },
  { value: 'destinationType', label: 'Destination Type', category: 'shipment' },
  { value: 'loadingPort', label: 'Loading Port', category: 'shipment' },
  { value: 'unloadingPort', label: 'Unloading Port', category: 'shipment' },
  { value: 'commodity', label: 'Commodity', category: 'shipment' },
  { value: 'hsCode', label: 'HS Code', category: 'shipment' },
  { value: 'incoterms', label: 'Incoterms', category: 'shipment' },
  { value: 'isHazardous', label: 'Hazardous Materials', category: 'shipment' },
  { value: 'readyDate', label: 'Ready Date', category: 'shipment' },
  { value: 'deliveryDate', label: 'Delivery Date', category: 'shipment' },
  { value: 'sailingDate', label: 'Sailing Date', category: 'shipment' },
  { value: 'totalWeight', label: 'Total Weight', category: 'shipment' },
  { value: 'totalVolume', label: 'Total Volume', category: 'shipment' },
  { value: 'specialRequirements', label: 'Special Requirements', category: 'shipment' },
]

export const SHIPMENT_CONTAINER_FIELD_OPTIONS = [
  { value: 'containers[].equipmentType', label: 'Container Equipment Type', category: 'shipment' },
  { value: 'containers[].quantity', label: 'Container Quantity', category: 'shipment' },
]

// Additional fields that can only be used in conditions (includes nested properties)
export const CONDITION_ONLY_RFQ_FIELDS = [
  { value: 'customer.id', label: 'Customer ID', category: 'rfq' },
  { value: 'consignee.id', label: 'Consignee ID', category: 'rfq' },
  { value: 'consignor.id', label: 'Consignor ID', category: 'rfq' },
  // { value: 'customer.name', label: 'Customer Name', category: 'rfq' },
  // { value: 'customer.code', label: 'Customer Code', category: 'rfq' },
  // { value: 'consignee.name', label: 'Consignee Name', category: 'rfq' },
  // { value: 'consignee.country', label: 'Consignee Country', category: 'rfq' },
  // { value: 'consignor.name', label: 'Consignor Name', category: 'rfq' },
  // { value: 'consignor.country', label: 'Consignor Country', category: 'rfq' },
]

export const CONDITION_ONLY_SHIPMENT_FIELDS = [
  { value: 'origin.country', label: 'Origin Country', category: 'shipment' },
  { value: 'origin.city', label: 'Origin City', category: 'shipment' },
  { value: 'destination.country', label: 'Destination Country', category: 'shipment' },
  { value: 'destination.city', label: 'Destination City', category: 'shipment' },
]

// Fields that can only be used in requirements (not in conditions)
export const REQUIREMENT_ONLY_RFQ_FIELDS: { value: string; label: string; category: string }[] = [
  // Currently no RFQ fields are requirement-only
]

export const REQUIREMENT_ONLY_SHIPMENT_FIELDS = [
  { value: 'packageLines', label: 'Package Lines', category: 'shipment' },
]
